import { FC } from 'react';

import * as RadixSlider from '@radix-ui/react-slider';

import { BaseComponentProps } from '../../../types/common';

import styles from './Slider.module.css';

export interface SliderProps extends BaseComponentProps {
  /**
   * The minimum value of the slider.
   */
  min?: RadixSlider.SliderProps['min'];
  /**
   * The maximum value of the slider.
   */
  max?: RadixSlider.SliderProps['max'];
  /**
   * The step value of the slider.
   */
  step?: RadixSlider.SliderProps['step'];
  /**
   * Whether the slider is disabled.
   */
  disabled?: RadixSlider.SliderProps['disabled'];
  /**
   * The value of the slider.
   */
  value?: RadixSlider.SliderProps['value'];
  /**
   * The default value of the slider.
   */
  defaultValue?: RadixSlider.SliderProps['defaultValue'];
  /**
   * The callback function that is called when the value of the slider changes.
   */
  onValueChange?: RadixSlider.SliderProps['onValueChange'];
  /**
   * The callback function that is called when the value of the slider is committed.
   */
  onValueCommit?: RadixSlider.SliderProps['onValueCommit'];
}

/**
 * An input where the user selects a value from within a given range.
 */
export const Slider: FC<SliderProps> = ({
  min = 0,
  max = 100,
  step = 1,
  ...rest
}) => {
  return (
    <RadixSlider.Root
      className={styles.slider}
      max={max}
      min={min}
      step={step}
      {...rest}
    >
      <RadixSlider.Track className={styles['slider-track']}>
        <RadixSlider.Range className={styles['slider-range']} />
      </RadixSlider.Track>
      <RadixSlider.Thumb className={styles['slider-thumb']} />
    </RadixSlider.Root>
  );
};
